import { MapPin, Phone, Mail, Instagram, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import LeadForm from "@/components/LeadForm";
import { trackEvent } from "@/lib/analytics";
import { BRAND } from "@/data";

const Contatti = () => (
  <div data-testid="contatti-page" className="bg-[#0c0c0c] pt-32">
    <Seo
      title="Contatti | Prenota il tuo Fotografo nella Tuscia Viterbese e a Roma"
      description="Contatta Salvatore Castelli, studio fotografico a Faleria (Viterbo). Prenota una consulenza gratuita per matrimoni, compleanni ed eventi nella Tuscia Viterbese e a Roma."
      path="/contatti"
    />
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-16">
      <Reveal>
        <span className="text-sm uppercase tracking-[0.3em] text-gold">Contatti</span>
        <h1 className="font-serif text-4xl md:text-6xl text-white font-light mt-6 max-w-3xl leading-tight">
          Prenota la tua consulenza gratuita
        </h1>
      </Reveal>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-16">
      {/* Local SEO copy + info */}
      <Reveal>
        <h2 className="font-serif text-2xl md:text-3xl text-white font-light">
          Studio fotografico a Faleria, al servizio della Tuscia Viterbese
        </h2>
        <p className="text-stone-400 mt-5 leading-relaxed">
          Se cerchi un <strong className="text-stone-200">fotografo di matrimonio nella Tuscia Viterbese</strong> o
          {" "}<strong className="text-stone-200">servizi fotografici per eventi a Roma</strong> sei nel posto
          giusto. Come <strong className="text-stone-200">fotografo di compleanni a Viterbo</strong> e con il mio
          {" "}<strong className="text-stone-200">studio fotografico a Faleria</strong> seguo personalmente ogni
          mio cliente dal primo contatto alla consegna finale.
        </p>

        <div className="mt-10 space-y-5">
          <a href={`tel:${BRAND.phoneIntl}`} onClick={() => trackEvent("contact_click", { method: "phone" })} data-testid="contact-phone" className="flex items-center gap-4 group">
            <span className="w-11 h-11 border border-stone-700 flex items-center justify-center text-gold group-hover:border-gold transition-colors"><Phone size={18} /></span>
            <span className="text-stone-300 group-hover:text-gold transition-colors">{BRAND.phone}</span>
          </a>
          <a href={`mailto:${BRAND.email}`} onClick={() => trackEvent("contact_click", { method: "email" })} data-testid="contact-email" className="flex items-center gap-4 group">
            <span className="w-11 h-11 border border-stone-700 flex items-center justify-center text-gold group-hover:border-gold transition-colors"><Mail size={18} /></span>
            <span className="text-stone-300 group-hover:text-gold transition-colors">{BRAND.email}</span>
          </a>
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" onClick={() => trackEvent("contact_click", { method: "instagram" })} data-testid="contact-instagram" className="flex items-center gap-4 group">
            <span className="w-11 h-11 border border-stone-700 flex items-center justify-center text-gold group-hover:border-gold transition-colors"><Instagram size={18} /></span>
            <span className="text-stone-300 group-hover:text-gold transition-colors">{BRAND.instagramHandle}</span>
          </a>
          <div className="flex items-center gap-4">
            <span className="w-11 h-11 border border-stone-700 flex items-center justify-center text-gold"><Clock size={18} /></span>
            <span className="text-stone-300">Lun – Sab · 9:00 – 20:00</span>
          </div>
        </div>

        {/* Coverage area */}
        <div className="mt-10 border border-stone-800 bg-[#111] p-6">
          <div className="flex items-center gap-2 text-gold mb-4">
            <MapPin size={18} />
            <span className="text-xs uppercase tracking-[0.2em]">Raggio di copertura</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {BRAND.areas.map((a) => (
              <span key={a} data-testid={`coverage-${a.toLowerCase().replace(/\s/g, "-")}`} className="border border-stone-700 text-stone-300 text-xs uppercase tracking-widest px-3 py-2">
                {a}
              </span>
            ))}
          </div>
          <div className="mt-5 overflow-hidden border border-stone-800">
            <iframe
              title="Mappa copertura Faleria"
              data-testid="coverage-map"
              src="https://www.google.com/maps?q=Faleria%20Viterbo&output=embed"
              className="w-full h-56 grayscale contrast-125 opacity-90"
              loading="lazy"
            />
          </div>
        </div>
      </Reveal>

      {/* Form */}
      <Reveal delay={150}>
        <div className="border border-stone-800 bg-[#111] p-8 md:p-10">
          <LeadForm
            defaultService="consulenza"
            title="Scrivimi"
            subtitle="Compila il modulo, ti ricontatterò al più presto per la tua consulenza gratuita."
          />
        </div>
      </Reveal>
    </section>
  </div>
);

export default Contatti;
